import React, { Component } from 'react';
import Header from "./../Components/Header.jsx"
import MainMenu from './../Components/MainMenu'
import ApxView from './ApxView.jsx';
import AOView from './AOView.jsx';
import OTView from './OTView.jsx';
import {MainMenuEnum} from './../Enums/Enums';
import AbacusSnackbar from './../Components/AbacusSnackbar';

class Main extends Component {
  constructor(props) {
    super(props);  
    this.props.data.Main.OpenMainView = this.openMainView.bind(this);
    this.props.data.Service.ErrorCallback = this.errorCallback.bind(this);
    this.props.data.Service.SuccessCallback = this.successCallback.bind(this);
    this.state={
      activeView:MainMenuEnum.Home,
      Snackbar_Open: false,
      Snackbar_ErrorText:""
    }
  }

  openMainView(index){
    this.setState({activeView:index});
  }

  snackClick(){
    this.setState({
      Snackbar_Open: false,
      Snackbar_ErrorText: ""
    })
  }

  // Error Callback. Opens Snackbar
  errorCallback(error){
    this.setState({
      Snackbar_Open: true,
      Snackbar_ErrorText: error,
      IsSnackbarError: true
    })
  }

  successCallback(error){
    this.setState({
      Snackbar_Open: true,
      Snackbar_ErrorText: error,
      IsSnackbarError: false
    })
  }

  render() {
    return (
      <div>
        <Header isShowExit={true}></Header>
        <MainMenu data={this.props.data}></MainMenu>
          {this.state.activeView===MainMenuEnum.Apx?<ApxView data={this.props.data}></ApxView>:null}
          {this.state.activeView===MainMenuEnum.AmicusOnline?<AOView data={this.props.data}></AOView>:null}
          {this.state.activeView===MainMenuEnum.OfficeTools?<OTView data={this.props.data}></OTView>:null}
          <AbacusSnackbar buttonStyle={this.state.IsSnackbarError?{color:"red"}:{color:"lightgreen"}} open={this.state.Snackbar_Open} message={this.state.Snackbar_ErrorText} onClick={this.snackClick.bind(this)}></AbacusSnackbar>
      </div>
    );
  }
}

export default Main;